// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2CbVk","head":"ProcedureTableInfo_head__3j5NH"};